import React from 'react';
import { Node } from 'reactflow';
import { NodeData, Position } from '../types';
import type { Edge } from 'reactflow';
import EdgeSidePanel from './edge-side-panel';
import NodeSidePanel from './node-side-panel';

interface SidePanelProps {
  selectedNode: Node<NodeData> | null;
  selectedEdge: Edge | null;
  onSave: (nodeId: string, data: NodeData, position: Position) => void;
  onDeleteEdge: (edgeId: string) => void;
  onAddEdgeKeyword: (edgeId: string, keyword: string) => void;
  onRemoveEdgeKeyword: (edgeId: string, keyword: string) => void;
}

const SidePanel: React.FC<SidePanelProps> = ({
  selectedNode,
  selectedEdge,
  onSave,
  onDeleteEdge,
  onAddEdgeKeyword,
  onRemoveEdgeKeyword
}) => {
  if (selectedEdge) {
    return (
      <EdgeSidePanel
        selectedEdge={selectedEdge}
        onDeleteEdge={onDeleteEdge}
        onAddEdgeKeyword={onAddEdgeKeyword}
        onRemoveEdgeKeyword={onRemoveEdgeKeyword}
      />
    );
  }
  if (selectedNode) {
    return <NodeSidePanel selectedNode={selectedNode} onSave={onSave} />;
  }
  return null;
};

export default SidePanel;
